import { createFeature, createReducer, on } from '@ngrx/store';
import { editOrderActions, editOrderApiActions } from './edit-order.actions';

export interface EditOrderState {
  isReady: boolean;
  isOutOfTradingTimes: boolean;
  orderId: string | null;
  errorMessage: string | null;
  isCancellingOrder: boolean;
  isCancellationTriggered: boolean;
  isCancellationDone: boolean;
}

export const initialState: EditOrderState = {
  isReady: false,
  isOutOfTradingTimes: false,
  orderId: null,
  errorMessage: null,
  isCancellingOrder: false,
  isCancellationTriggered: false,
  isCancellationDone: false,
};

export const editOrderFeature = createFeature({
  name: 'editOrder',
  reducer: createReducer(
    initialState,
    on(editOrderActions.clearState, (): EditOrderState => initialState),
    on(
      editOrderActions.cancelOrder,
      (state, { orderId }): EditOrderState => ({
        ...state,
        isCancellationDone: false,
        isCancellingOrder: true,
        orderId,
      }),
    ),
    on(
      editOrderApiActions.cancelOrderSuccess,
      (state): EditOrderState => ({
        ...state,
        errorMessage: null,
        isCancellationTriggered: true,
      }),
    ),
    on(
      editOrderApiActions.cancelOrderFailure,
      (state, { error }): EditOrderState => ({
        ...state,
        errorMessage: error.message,
        isCancellingOrder: false,
      }),
    ),
    on(
      editOrderApiActions.checkCancelStateSuccess,
      (state, { isCancellationDone }): EditOrderState => ({
        ...state,
        isCancellationDone,
        isCancellingOrder: !isCancellationDone,
        isCancellationTriggered: false,
      }),
    ),
    on(
      editOrderApiActions.checkCancelStateFailure,
      (state, { error }): EditOrderState => ({
        ...state,
        isCancellingOrder: false,
        isCancellationTriggered: false,
        errorMessage: error.message,
      }),
    ),
    on(
      editOrderApiActions.checkTradingTimesSuccess,
      (state, { isOutOfTradingTimes }): EditOrderState => ({
        ...state,
        isReady: true,
        isOutOfTradingTimes,
      }),
    ),
    on(
      editOrderApiActions.checkTradingTimesFailure,
      (state, { error }): EditOrderState => ({
        ...state,
        isReady: false,
        errorMessage: error.message,
      }),
    ),
    on(editOrderActions.resetTimer, (state): EditOrderState => ({ ...state, isCancellingOrder: false, isCancellationTriggered: false })),
  ),
});
